var render = function render(_c,_vm){return _c('div',{staticClass:"spacer"})
}
var staticRenderFns = []

export { render, staticRenderFns }